import { render, staticRenderFns } from "./PromoTab.vue?vue&type=template&id=79ed544e&scoped=true&"
import script from "./PromoTab.vue?vue&type=script&lang=js&"
export * from "./PromoTab.vue?vue&type=script&lang=js&"
import style0 from "./PromoTab.vue?vue&type=style&index=0&id=79ed544e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed544e",
  null
  
)

export default component.exports